import isValidEmailAddress from 'owa-readwrite-recipient-well/lib/utils/isValidEmailAddress';
export default function convertPersonaToRecipientPersonaProps(personas, validationNeeded) {
    if (personas) {
        var recipientPersonaProps = personas.map(function (obj) {
            var recipientPersonaProp = {
                persona: obj,
                displayText: obj.EmailAddress.Name,
                isValid: validationNeeded
                    ? isValidEmailAddress(obj.EmailAddress.EmailAddress)
                    : true,
                isSelected: false,
                isExpanding: false,
                isContextMenuOpen: false,
                primaryText: obj.EmailAddress.Name,
                canExpand: (obj.EmailAddress.MailboxType == 'PrivateDL' ||
                    obj.EmailAddress.MailboxType == 'PublicDL' ||
                    obj.EmailAddress.MailboxType == 'GroupMailbox') &&
                    obj.PersonaId != null,
            };
            return recipientPersonaProp;
        });
        return recipientPersonaProps;
    }
    else {
        return [];
    }
}
//# sourceMappingURL=convertPersonaToRecipientPersonaProps.js.map